import { GoogleMap, Marker } from '@react-google-maps/api';
import React, { useEffect, useRef, useState } from 'react';

import { useAppBranding } from '../../../../config/branding';
import { useGoogleMaps } from '../../../../contexts/google-map-context/GoogleMapContent';
import { useAppSelector } from '../../../../redux/hooks';
import device from '../../../../utils/api/device';

/**
 * check the lat and lng is valid or not
 * @param position
 * @returns
 */
const validatePosition = (position: { latitude: any; longitude: any }) => {
  const lat = parseFloat(position.latitude);
  const lng = parseFloat(position.longitude);
  return !Number.isNaN(lat) && !Number.isNaN(lng) ? { lat, lng } : null;
};

/**
 * Component to display device map
 * @returns
 */
function DeviceMap() {
  const branding = useAppBranding();
  const { isLoaded } = useGoogleMaps();
  const mapReference = useRef<google.maps.Map | null>(null);
  const { selectedChargingPoint } = useAppSelector((state) => state.device);

  const [chargingPointLocation, setChargingPointLocation] = useState<{
    latitude: string;
    longitude: string;
  }>({
    latitude: '0',
    longitude: '0',
  });

  const containerStyle = {
    width: '100%',
    height: '100%',
  };

  /**
   * General details
   * @param chargingPointSn
   */
  const handleFetchDeviceLocation = async (id: string) => {
    try {
      const response = await device.fetchChargingPointLocation(id);
      setChargingPointLocation(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedChargingPoint) {
      handleFetchDeviceLocation(selectedChargingPoint.id);
    }
  }, [selectedChargingPoint]);

  return (
    <div className="device-map-wrap">
      <div className="device-map-toggle">
        {/* <h6></h6>
        <h6></h6> */}
      </div>
      <div className="device-map-container">
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={{
              lat: Number(chargingPointLocation.latitude),
              lng: Number(chargingPointLocation.longitude),
            }}
            zoom={5}
            onLoad={(map) => {
              mapReference.current = map; // Assign the map instance to the reference
            }}>
            {chargingPointLocation &&
              (() => {
                const validPosition = validatePosition(chargingPointLocation);
                return validPosition ? (
                  <Marker
                    key="01"
                    position={validPosition}
                    // clusterer={clusterer}
                    icon={{
                      url: branding.icons.stationLocator,
                      scaledSize: new window.google.maps.Size(44, 44), // Width, Height
                    }}
                  />
                ) : null;
              })()}
          </GoogleMap>
        ) : null}
      </div>
    </div>
  );
}

export default DeviceMap;
